import { Text, Box, HStack } from '@chakra-ui/react';
import { IconType } from 'react-icons';

interface SuggestionsButtonProps {
  isActive?: boolean;
  isDisabled?: boolean;
  label: string;
  icon?: IconType | null;
  onClick?: () => void;
  customIcon?: TODO;
}

export const SuggestionsButton = ({
  isActive,
  isDisabled,
  label,
  icon,
  onClick,
  customIcon,
}: SuggestionsButtonProps) => {
  return (
    <HStack
      spacing="2"
      align="center"
      px="5"
      py="2"
      rounded="full"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      onClick={isDisabled ? () => null : onClick}
      color={isActive ? 'white' : 'black'}
      backgroundColor={isActive ? 'blackAlpha.800' : 'blackAlpha.50'}
      _hover={
        isDisabled
          ? { textDecoration: 'none' }
          : { textDecoration: 'underline' }
      }
    >
      {/* Label */}
      <Text fontWeight="medium" size="sm" whiteSpace="nowrap">
        {label}
      </Text>
    </HStack>
  );
};
